module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.slotComponent) ? _c(_vm.slotComponent, _vm._b({
    tag: "component",
    staticClass: "slot-body"
  }, 'component', _vm.slotProps, false)) : _c('div', {
    staticClass: "default-body"
  }, [_vm._v(_vm._s(_vm.text))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67b52c4d","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppModal/components/Body.vue
// module id = f18ba110cc75555c7ba6
// module chunks = 89